import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const appName = config.appName;
// const baseUrl = config.baseUrl;
// const service = 'jernygateway';

// use default datacollector playground
const baseUrl = 'http://localhost:8080';
const service = 'datacollector';

// Gateway service name — routes document endpoints via jernygateway

class DocumentService extends ServiceBase {
    /**
     * Fetches all documents linked to a journal entry.
     * @param {any} dto - Journal entry RK
     * @returns axios response
     */
    postDocument = (dto) => {
        // 42ecc4b6-8c2c-4408-9028-1528b6dabbae
        // d450235d-0dfc-4b83-9135-828fd72b0144
        const url = `${baseUrl}/${service}/document`;

        const cfg = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        // Wrap in data envelope — consistent with postPrioUpdate pattern
        return agent.post(url, { data: dto }, cfg);
    };

    /**
     * Fetches all documents linked to a journal entry.
     * @param {string} jid - Journal entry RK
     * @returns axios response
     */
    getDocuments = (jid) => {
        // const url = `${baseUrl}/${service}/documents?rid=${jid}&app=${appName}`;

        const url = `http://localhost:8080/datacollector/documents?rid=${jid}&app=${appName}`;
        const cfg = {
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return agent.get(url, cfg);
    };

    /**
     * Updates document state.
     * @param {object} req - { rk, stateId }
     * @returns {Promise}
     */
    patchDocument = (req) => {
        const url = `${baseUrl}/${service}/document`;
        const cfg = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        // Wrap in data envelope — consistent with postPrioUpdate pattern
        return agent.patch(url, { data: req }, cfg);
    };

    /**
     * Saves a new document linked to a journal entry.
     * @param {object} dto - { jid, url, fileName, mimeType, size, description, storageProvider }
     * @returns axios response
     */
    saveDocument = (dto) => {
        const url = `${baseUrl}/${service}/documents`;
        const cfg = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        // Wrap in data envelope — consistent with postPrioUpdate pattern
        return agent.post(url, { data: dto }, cfg);
    };

    /**
     * Deletes a document by RK.
     * @param {string} rk - Document RK
     * @returns axios response
     */
    deleteDocument = (dto) => {
        const url = `${baseUrl}/${service}/document`;
        const cfg = {
            data: { data: dto },
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return agent.delete(url, cfg);
    };
}

const documentService = new DocumentService();
export default documentService;
